module.exports = __webpack_public_path__ + "static/media/dancing.a84ce917.jpg";